import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  getEmtpyBoxReport,
  getLocationBrands,
  updateLocationBrands,
} from "../../services/box/box";
import { Context } from "../../context/app_context";
import EmptyBoxReportTable from "./table";
import Loading from "../loading/loading";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { SelectWrapper } from "../box/table_styled";

export default function ResultPanelRenderEmtpyBoxReport() {
  const { setLoading, currentTab } = useContext(Context);
  const [reportData, setReportData] = useState();
  const [brands, setBrands] = useState([]);
  const [brandFilter, setBrandFilter] = useState("");

  const loadReportData = async () => {
    setLoading(true);
    const createResponse = await getEmtpyBoxReport(brandFilter);
    if (createResponse.status === 200) {
      setReportData(createResponse.data);
    } else {
      toast.error("Error loading report");
    }
    setLoading(false);
  };

  const loadBrandsFilter = async () => {
    setLoading(true);
    const createResponse = await getLocationBrands();
    if (createResponse.status === 200) {
      setBrands(createResponse.data);
    } else {
      toast.error("Error loading brands");
    }
    setLoading(false);
  };

  const handleUpdateLocationBrands = async () => {
    setLoading(true);
    const createResponse = await updateLocationBrands();
    if (createResponse.status === 200) {
      toast.success("Location Brands Updated Successful");
    } else {
      toast.error("Error loading brands");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadReportData();
  }, [brandFilter]);

  useEffect(() => {
    loadBrandsFilter();
    loadReportData();
  }, []);
  if (currentTab === 3) {
    return (
      <>
        <Loading />
        <SelectWrapper>
          <FormControl sx={{ minWidth: "160px" }}>
            <InputLabel id="demo-simple-select-label">Brand</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={brandFilter}
              label="Brand"
              onChange={(event: SelectChangeEvent<string>) => {
                setBrandFilter(event.target.value);
              }}
            >
              <MenuItem value={"NONE"}>NONE</MenuItem>
              {brands
                ?.filter((x: { brand: string }) => x.brand)
                .map((brand: { brand: string }) => {
                  return (
                    <MenuItem key={`index_${brand.brand}`} value={brand.brand}>
                      {brand.brand}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
          <Button
            color="primary"
            variant="contained"
            sx={{ borderRadius: 100, color: "white", paddingX: "2rem" }}
            onClick={handleUpdateLocationBrands}
            data-cy="handle_update_location_brands"
          >
            Update Location Brands
          </Button>
        </SelectWrapper>

        <EmptyBoxReportTable data={reportData || {}} reload={loadReportData} />
      </>
    );
  } else {
    return <></>;
  }
}
